import { Module } from 'vuex';
import { RootState } from '../store';
import { mutations } from '../mutations/archive.mutations';
import { actions } from '../actions/archive.actions';
import { ITeam } from '@/types/Team';
import { ITag } from '@/types/Tag';
import GroupFiltersEnum from '@/enums/GroupFilters';

export const namespace = 'archive';

export interface ArchiveState {
  tags: ITag[];
  isLoadingTeams: boolean;
  isLoadingTags: boolean;
  error: string;
  teams: ITeam[];
  endDateFilter: IDateFilter;
  scopeFilter: IScopeFilter;
  tagFilter: string;
  groupFilter: GroupFiltersEnum;
}

export interface IDateFilter {
  from?: Date;
  to?: Date;
  month?: Date;
  range: string;
}

export interface IScopeFilter {
  users: string[];
}

export const state: ArchiveState = {
  isLoadingTeams: false,
  isLoadingTags: false,
  error: '',
  teams: [],
  tags: [],
  endDateFilter: {
    from: null,
    to: null,
    month: null,
    range: '',
  },
  scopeFilter: {
    users: [],
  },
  tagFilter: '',
  groupFilter: GroupFiltersEnum.my,
};

const namespaced: boolean = true;

export const archive: Module<ArchiveState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
